import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'institutes' })
export class Institute extends HierarchyNode {}
